import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../home/Icon';
import { useOffline } from '../context/OfflineContext';
import { ROUTES } from '../../util/routes';
import useWikis from '../../hooks/useWikis';
import ReconnectButton from './ReconnectButton';
import '../styles/MainContainer.css';
import './OfflineUnavailable.css';

// Direkte Sprungziele, die offline funktionieren (siehe OFFLINE_CAPABLE in AppShell); dazu die Wikis aus der
// lokalen Kopie.
const OFFLINE_PAGES = [
  { to: ROUTES.HOME, icon: 'home', label: 'Dashboard' },
  { to: ROUTES.PRICES, icon: 'sell', label: 'Preisliste' },
];

// Platzhalter für reine Online-Seiten, die im Offline-Modus geöffnet werden — statt einer leeren Liste.
function OfflineUnavailable() {
  const { reconnectFailed } = useOffline();
  const { wikis } = useWikis();
  const pages = [
    ...OFFLINE_PAGES,
    ...wikis.map(w => ({ to: ROUTES.wiki(w.id), icon: w.icon, label: w.name })),
  ];

  return (
    <main className="defaultMain">
      <section className="offlineUnavailable" role="status" aria-live="polite">
        <div className="offlineUnavailableGlyph">
          <Icon className="offlineUnavailableIcon" icon="cloud_off" />
        </div>
        <h2 className="offlineUnavailableTitle">Offline nicht verfügbar</h2>
        <p className="offlineUnavailableText">
          Diese Seite braucht eine Internetverbindung. Offline erreichbar sind:
        </p>
        <nav className="offlineUnavailableLinks" aria-label="Offline verfügbare Seiten">
          {pages.map(page => (
            <Link key={page.to} to={page.to} className="offlineUnavailableLink">
              <Icon className="offlineUnavailableLinkIcon" icon={page.icon} />
              {page.label}
            </Link>
          ))}
        </nav>
        <p className="offlineUnavailableNote">
          Den nächsten Spieltag öffnest du offline über das Dashboard – als eingetragener Spieltagleiter.
        </p>
        <ReconnectButton />
        {reconnectFailed && <p className="offlineUnavailableFailed">Weiterhin keine Verbindung.</p>}
      </section>
    </main>
  );
}

export default OfflineUnavailable;
